// Copyright (c) Docugami, Inc. All rights reserved.
export enum CorrelationStatus {
    Unknown = "Unknown",
    Inserted = "Inserted",
    Deleted = "Deleted",
    Equal = "Equal",
}
